// Shared components
import { CountrySelectComponent } from '@components/shared/country-select/country-select.component';
import { TranslateModule } from '@ngx-translate/core';
import { IBookingModel } from '@services/api/booking/booking-model.interface';
import { LogService } from '@services/util/log.service';
import { InputNumberModule } from 'primeng/inputnumber';
// PrimeNG imports
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BookingActionEvent } from '../../models/booking-detail.model';
import { BookingChangeTrackerService } from '../../services/booking-change-tracker.service';

@Component({
  selector: 'app-booking-billing-tab',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, InputTextModule, InputNumberModule, CountrySelectComponent],
  templateUrl: './booking-billing-tab.component.html'
})
export class BookingBillingTabComponent implements OnInit {
  // Services
  readonly changeTracker = inject(BookingChangeTrackerService);
  private readonly logService = inject(LogService);
  @Input() booking: IBookingModel | null = null;
  @Output() actionEvent = new EventEmitter<BookingActionEvent>();

  loading = false;

  ngOnInit(): void {
    // Any initialization logic can go here
  }

  /**
   * Handle billing information changes for a specific field
   * @param fieldName Name of the field that changed
   * @param newValue New value of the field
   */
  onFieldChange(fieldName: string, newValue: any): void {
    // Emit field change to parent component
    if (this.booking) {
      this.actionEvent.emit({
        action: 'field-change',
        booking: this.booking,
        additionalData: {
          fieldName,
          newValue
        }
      });
    }
  }

  /**
   * Handle billing information changes
   * Legacy method kept for backward compatibility
   */
  onBillingInfoChange(): void {
    // This is now handled by more granular field change tracking
    // No-op for backward compatibility
  }
}
